// src/pages/SupplierListPage.jsx
import React, { useState, useEffect } from 'react';
import api from '../api'; // Your axios instance
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

export default function SupplierListPage() {
  const [suppliers, setSuppliers] = useState([]);
   const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({ Name: '', Phone: '', GSTIN: '', Address: '', OpeningBalance: '' });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const fetchSuppliers = async () => {
    const res = await api.get('/purchase/suppliers');
    setSuppliers(res.data);
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (editingId) {
      await api.put(`/purchase/suppliers/${editingId}`, form);
    } else {
      await api.post('/purchase/suppliers', form);
    }
    setForm({ Name: '', Phone: '', GSTIN: '', Address: '', OpeningBalance: '' });
    setEditingId(null);
    fetchSuppliers();
  };

  const handleEdit = supplier => {
    setForm(supplier);
    setEditingId(supplier.SupplierID);
  };

  const handleDelete = async id => {
    if (window.confirm('Delete this supplier?')) {
      await api.delete(`/purchase/suppliers/${id}`);
      fetchSuppliers();
    }
  };

  const filtered = suppliers.filter(s =>
    s.Name.toLowerCase().includes(search.toLowerCase()) ||
    (s.Phone || '').includes(search) ||
    (s.GSTIN || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <h2>Suppliers</h2><BackButton></BackButton>
      <form className="row g-2 mb-3" onSubmit={handleSubmit}>
        <div className="col-md-2">
          <input className="form-control" name="Name" placeholder="Name" value={form.Name} onChange={handleChange} required />
        </div>
        <div className="col-md-2">
          <input className="form-control" name="Phone" placeholder="Phone" value={form.Phone} onChange={handleChange} />
        </div>
        <div className="col-md-2">
          <input className="form-control" name="GSTIN" placeholder="GSTIN" value={form.GSTIN} onChange={handleChange} />
        </div>
        <div className="col-md-3">
          <input className="form-control" name="Address" placeholder="Address" value={form.Address} onChange={handleChange} />
        </div>
        <div className="col-md-2">
          <input className="form-control" name="OpeningBalance" placeholder="Opening Balance" type="number" value={form.OpeningBalance} onChange={handleChange} />
        </div>
        <div className="col-md-1">
          <button className="btn btn-primary w-100" type="submit">
            {editingId ? 'Update' : 'Add'}
          </button>
        </div>
      </form>

      <input
        className="form-control mb-2"
        placeholder="Search by name, phone, or GSTIN"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>GSTIN</th>
            <th>Address</th>
            <th>Opening Balance</th>
            <th>Total Bills</th>
            <th>Total Paid</th>
            <th>Balance</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(s => (
            <tr key={s.SupplierID}>
              <td>{s.Name}</td>
              <td>{s.Phone}</td>
              <td>{s.GSTIN}</td>
              <td>{s.Address}</td>
              <td>{parseFloat(s.OpeningBalance || 0).toFixed(2)}</td>
              <td>{parseFloat(s.TotalBills || 0).toFixed(2)}</td>
              <td>{parseFloat(s.TotalPaid || 0).toFixed(2)}</td>
              <td
                className={parseFloat(s.Balance) === 0
                  ? "text-success"
                  : "text-danger"}
              >
                {parseFloat(s.Balance).toFixed(2)}
              </td>
              <td>
                <button className="btn btn-sm btn-secondary me-1" onClick={() => handleEdit(s)}>Edit</button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(s.SupplierID)}>Delete</button>
             <button
          className="btn btn-sm btn-info"
          onClick={() => navigate(`/suppliers/${s.SupplierID}/ledger`)}
        >
          Ledger
        </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
